import { LinkButton } from "@/components/ui/LinkButton";

/**
 * 404 Not Found page.
 * Console-style: an oversized mono status code over a terse explanation and a
 * single home action. Uses semantic color tokens from the design system.
 * @returns The not found page component
 */
export function NotFoundPage() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-background px-4">
      <div className="w-full max-w-md text-center">
        <span className="inline-flex items-center gap-1.5 rounded-full border border-neutral-200 bg-surface px-3 py-1 text-xs font-medium uppercase tracking-wide text-neutral-500">
          <span className="size-1.5 rounded-full bg-destructive-500" />
          Not found
        </span>
        <h1 className="mt-6 font-mono text-7xl font-semibold tabular-nums tracking-tight text-neutral-900 sm:text-8xl">
          404
        </h1>
        <h2 className="mt-4 text-2xl font-semibold tracking-tight text-neutral-900">
          Page Not Found
        </h2>
        <p className="mt-2 text-sm text-neutral-600">
          Sorry, we couldn&apos;t find the page you&apos;re looking for.
        </p>
        <div className="mt-8 flex justify-center">
          <LinkButton to="/">Go Home</LinkButton>
        </div>
      </div>
    </div>
  );
}
